export default __webpack_public_path__ + "25bb2ae0d3a5e1ebdcf02d13270f6cb0.png";